import { isPbxRecordingUnavailableError, triggerPbxRecordingDownload } from "./ncrmPbx.mjs";

// Sub-flow-ul de download al înregistrărilor PBX din timeline-ul de activități.
// Extras din `NcrmActivityTimeline.vue` (fișier peste pragul de dimensiune) conform
// regulii din docs/engineering/modularity.md: bucata atinsă se mută într-un modul nou.
//
// Componenta gazdă trebuie să expună:
// - `downloadingRecordingId` în `data()` (folosit pentru starea de loading per activitate)
// - `showSnackbar(message, color)` ca metodă
export const ncrmActivityTimelineRecordingMethods = {
  // Un apel are înregistrare descărcabilă doar dacă sync-ul PBX a marcat
  // `recording_available` în `type_payload` și avem `call_log_id` valid.
  resolveRecordingCallId(activity) {
    const payload = activity?.type_payload;
    if (!payload || typeof payload !== "object") return null;
    if (!payload.recording_available || !payload.recording_id) return null;
    const callLogId = Number(payload.call_log_id);
    return Number.isFinite(callLogId) && callLogId > 0 ? callLogId : null;
  },
  async downloadRecording(activity) {
    const callId = this.resolveRecordingCallId(activity);
    if (!callId || this.downloadingRecordingId) return;
    this.downloadingRecordingId = activity.id;
    try {
      await triggerPbxRecordingDownload(callId);
    } catch (error) {
      const unavailable = isPbxRecordingUnavailableError(error);
      this.showSnackbar(
        unavailable
          ? this.$t("ncrm.integrations.pbx.snackbar.recordingUnavailable")
          : this.$t("ncrm.integrations.pbx.snackbar.recordingError"),
        unavailable ? "warning" : "error"
      );
    } finally {
      this.downloadingRecordingId = null;
    }
  },
};
